
export const SERVER_URL = "https://gw.cssat.cn"; // 正式环境
export const DEVELOPMENT_SERVER_URL = "https://ysslapi.cssat.cn"; //开发环境

